export default {
	alternative: "Alternative",
	alternatives_justification: "Alternatives with explanation",
	alternatives: "Alternatives",
	answer: "Answer",
	answers: "Answers",
	basic_data: "Basic data",
	clients: "Clients",
	dissertative: "Essay",
	end_date: "End date",
	justification: "Explanation",
	justify: "Explain",
	mandatory: "Mandatory",
	multiple_choices_justification: "Multiple choice with explanation",
	multiple_choices: "Multiple choice",
	no_questions_are_defined: "No questions defined",
	no_survey_avaliable: "No survey available",
	optional: "Optional",
	owners: "Owners",
	permission: "Permission",
	permissions: "Permissions",
	question_save_error: "Question saved with error",
	question_save_success: "Question saved successfully",
	question_type: "Question type",
	question: "Question",
	questions_quantity: "Number of questions",
	questions: "Questions",
	score: "Score",
	select_at_least_one_option: "Select at least one option",
	start_date: "Start date",
	survey_published_success: "Survey publish success",
	survey_save_error: "Survey saved with error",
	survey_save_success: "Survey saved successfully",
	survey_type: "Survey type",
	survey_unpublished_success: "Survey unpublish success",
	survey_people_answered_quantity: "Number of people who answered",
	survey_people_answered_percentage: "Answers (%)",
	surveys: "Surveys",
	user_answers: "User answers",
	survey_anonymous_results_label: "This survey is anonymous."
}
